import React, { useState } from 'react';
import Select from 'react-select';

// Example mock data for tourist attractions with more detailed information
const touristAttractions = [
  { 
    id: 1, 
    name: 'مسجد الأقصى', 
    type: 'إسلامي', 
    location: 'القدس، فلسطين', 
    description: 'مسجد الأقصى هو واحد من أقدم وأهم المساجد في العالم، يقع في قلب القدس.', 
    image: 'https://encrypted-tbn1.gstatic.com/licensed-image?q=tbn:ANd9GcQPyJL_a8K7RKskq5J2w8PoD9nB7EUhRczqNaHShgCGDeNQmFtYoRiS7gUA4hk4cDCeTYaCUpG8roXzj65fUFffnH_B1V0c2IldDwF_KA', 
    hours: 'مفتوح يومياً من 8 صباحاً حتى 5 مساءً', 
    website: 'https://www.al-aqsa.org', 
    rating: 4.8
  },
  { 
    id: 2, 
    name: 'شلالات نياجارا', 
    type: 'طبيعي', 
    location: 'نياجارا، كندا/الولايات المتحدة الأمريكية', 
    description: 'إحدى عجائب الطبيعة الأكثر شهرة في العالم، تجذب شلالات نياجارا ملايين الزوار سنوياً.', 
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEmOoTLbrn8XcS10H9ktOW7PBBUPK4dkO-ow&s ', 
    hours: 'مفتوح على مدار السنة', 
    website: 'https://www.niagarafallstourism.com', 
    rating: 4.9 
  },
  { 
    id: 3, 
    name: 'برج إيفل', 
    type: 'حديث', 
    location: 'باريس، فرنسا', 
    description: 'برج إيفل هو برج حديدي على شكل شبكي في ساحة شام دي مارس في باريس، سُمّي على اسم المهندس غوستاف إيفل.', 
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbKvAGNLY2ORzaC2FB__nuW9ae5xLWSzWjdg&s', 
    hours: 'مفتوح يومياً من 9 صباحاً حتى منتصف الليل', 
    website: 'https://www.toureiffel.paris', 
    rating: 4.7 
  },
  { 
    id: 4, 
    name: 'الكولوسيوم', 
    type: 'تاريخي', 
    location: 'روما، إيطاليا', 
    description: 'الكولوسيوم هو مدرج قديم يقع في وسط روما، وهو واحد من أعظم الأعمال الهندسية والمعمارية الرومانية.', 
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQRJwTdkZnA7JUH1rqdZxi5thDobk4f6K29Q&s', 
    hours: 'مفتوح يومياً من 8:30 صباحاً حتى 7 مساءً', 
    website: 'https://www.coopculture.it/en/colosseo-e-shop.cfm', 
    rating: 4.8 
  },
  { 
    id: 5, 
    name: 'سور الصين العظيم', 
    type: 'تاريخي', 
    location: 'الصين', 
    description: 'سور الصين العظيم هو سلسلة من التحصينات المبنية من مواد مختلفة، تم بناؤها لحماية الحدود الشمالية للصين.', 
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdUPMkwDzOY5MOcZ1Qi0TtsT3cNhJSnLyjcg&s', 
    hours: 'مفتوح يومياً من 8 صباحاً حتى 5 مساءً', 
    website: 'http://www.greatwall-of-china.com', 
    rating: 4.9 
  },
];

const TouristAttractionPage = () => {
  const [selectedType, setSelectedType] = useState(null);
  const [filteredAttractions, setFilteredAttractions] = useState(touristAttractions);

  // Available categories for filtering
  const categories = ['إسلامي', 'طبيعي', 'ثقافي', 'تاريخي', 'حديث'];

  // Handle filter change
  const handleFilterChange = (selectedOption) => {
    setSelectedType(selectedOption);
    if (selectedOption) {
      setFilteredAttractions(touristAttractions.filter(attraction => attraction.type === selectedOption.value));
    } else {
      setFilteredAttractions(touristAttractions);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-4xl font-bold text-center mb-6 text-green-700">المعالم السياحية حول العالم</h1>

      {/* Filter Section */}
      <div className="mb-6 text-center">
        <Select
          options={categories.map(category => ({ value: category, label: category }))}
          onChange={handleFilterChange}
          placeholder="اختر نوع المعلم السياحي"
          className="w-1/2 mx-auto"
        />
      </div>

      {/* Attractions List */}
      <div>
        <h2 className="text-2xl font-semibold mb-4">المعالم السياحية</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredAttractions.map((attraction) => (
            <div key={attraction.id} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img src={attraction.image} alt={attraction.name} className="w-full h-56 object-cover rounded-lg" />
                <div className="absolute top-4 left-4 bg-green-700 text-white px-4 py-2 rounded-full">{attraction.type}</div>
              </div>
              <h3 className="font-semibold text-xl mt-4">{attraction.name}</h3>
              <p className="text-gray-500 text-sm">{attraction.location}</p>
              <p className="text-gray-700 mt-2">{attraction.description}</p>
              <p className="text-gray-600 mt-2"><strong>ساعات العمل:</strong> {attraction.hours}</p>
              <div className="flex items-center mt-2">
                <span className="font-semibold mr-2">التقييم:</span>
                <span className="text-yellow-500">{'★'.repeat(Math.round(attraction.rating))}</span>
                <span className="text-gray-500 ml-2">({attraction.rating})</span>
              </div>
              <a href={attraction.website} target="_blank" rel="noopener noreferrer" className="text-green-700 mt-4 inline-block">
                زيارة الموقع
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TouristAttractionPage;
